import React from 'react';

import InflowSpinner from 'App/components/spinner/inflowSpinner';
import {requestAutoAuthentication} from 'App/features/user/userSaga';
import {connectToUser} from 'App/features/user/userSlice';

class AutoAuth extends React.Component {
  componentDidMount() {
    this.props.dispatch(requestAutoAuthentication());
  }

  render() {
    const {isAutoAuthenticationDone, children} = this.props;

    return isAutoAuthenticationDone ? children : <InflowSpinner />;
  }
}

export default connectToUser(AutoAuth);
